import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { sendSignInLinkToEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Mail } from 'lucide-react';
const AUTH_EMAIL_KEY = 'auth_email_for_sign_in';

const EmailSignInForm = ({ 
  email, 
  setEmail, 
  status, 
  setStatus, 
  authError 
}) => {
  const [showInputRing, setShowInputRing] = React.useState(false);
  const [placeholderText, setPlaceholderText] = React.useState("Deine Email...");

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setShowInputRing(true);
      setPlaceholderText("Bitte gib deine Email ein.");
      setTimeout(() => {
        setShowInputRing(false);
        setPlaceholderText("Deine Email...");
      }, 1230);
      return;
    }

    setStatus('sending');
  
    const actionCodeSettings = {
      url: `${window.location.origin}/erstellen?email=${encodeURIComponent(email)}`,
      handleCodeInApp: true,
      expires: Date.now() + 3600000, // 1 hour from now
    };
  
    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      sessionStorage.setItem(AUTH_EMAIL_KEY, email);
      localStorage.setItem(AUTH_EMAIL_KEY, email);
      setStatus('sent');
      setEmail('');
    } catch (error) {
      console.error('Error sending sign-in link', error);
      setStatus('error');
    }
  };

  return (
    <motion.div
      className="w-full max-w-xl mx-auto mb-[calc(12svh+env(safe-area-inset-bottom))] pb-[calc(env(safe-area-inset-bottom)+env(keyboard-inset-height,0px))]"
      layout="position"
    >
      <div className="max-w-4xl mx-auto px-4 py-4">
        <form
          onSubmit={handleSubmit}
          className="flex flex-col items-center space-y-2"
        >
          <AnimatePresence mode="wait">
            {status === "sent" ? (
              <motion.button
                className="h-16 px-6 py-4 rounded-full bg-[#FFF3DD] text-[#343434] text-base sm:text-lg text-center outline-none flex items-center justify-center w-full"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ 
                  duration: 0.3,
                  ease: [0.4, 0, 0.2, 1]
                }}
              >
                <div className="flex items-center gap-2">
                  <Mail className="w-5 h-5 relative bottom-[1px]" />
                  <span>Öffne deine E-Mails und los geht's!</span>
                </div>
              </motion.button>
            ) : (
              <motion.div
                className="flex flex-col sm:flex-row w-full sm:space-x-2 space-y-2 sm:space-y-0"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.2 }}
              >
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={placeholderText}
                  autoComplete="email"
                  className={`h-16 px-6 py-4 rounded-full bg-[#FFF3DD] text-[#343434] font-freeman text-[1.25rem] font-normal leading-[110%] tracking-[-0.0375rem] text-center outline-none ${
                    showInputRing ? 'ring-4' : ''
                  } ring-[#FFA23E] transition-all duration-300 placeholder:text-[#343434] placeholder:font-freeman w-full sm:w-1/2 focus:ring-2`}
                  disabled={status === "sending"}
                />
                <button
                  type="submit"
                  disabled={status === "sending"}
                  className={`h-16 bg-[#FFA23E] text-[#343434] px-4 sm:px-6 py-2 sm:py-4 rounded-full font-freeman text-[1.25rem] font-normal leading-[110%] tracking-[-0.0375rem] flex flex-col items-center justify-center w-full sm:w-1/2 ${
                    status === "sending"
                      ? "cursor-not-allowed"
                      : "hover:bg-[#FF9925] transition-colors duration-300"
                  }`}
                >
                  <span className="whitespace-normal sm:whitespace-nowrap">
                    Jetzt Geschichte erstellen
                  </span>
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </form>
      </div>
      {authError ? (
        <div className="text-red-500 text-center mb-4">{authError}</div>
      ) : status === "error" ? (
        <p className="text-red-500 text-center">
          Da ist was schief gelaufen. Bitte versuch's nochmal.
        </p>
      ) : (
        <p className="text-center text-[#343434]">
          Deine personalisierte Hörgeschichte nur <strong>3,90€</strong>.
        </p>
      )}
    </motion.div>
  );
};

export default EmailSignInForm; 